module.exports = __webpack_public_path__ + "static/media/top-fv2.e30a0c04.JPG";